<div class="modal-container">
  <div class="modal-header-unassign-driver-modal">
    <span class="modal-header-title">{{ modalTitle }}</span>

    <button class="close-modal" (click)="cancel()">×</button>
  </div>

  <div class="modal-body-unassign-driver-modal">
    <span class="modal-body-text" [innerHTML]="messageHtml"></span>
  </div>

  <div class="modal-footer-unassign-driver-modal">
    <button type="button" class="cancel-button" (click)="cancel()">
      {{ "general_texts.cancel" | translate }}
    </button>

    <button
      type="button"
      class="confirm-button"
      (click)="onConfirm()"
      [disabled]="loading"
    >
      <ng-container *ngIf="!loading">
        {{ "general_texts.confirm" | translate }}
      </ng-container>
      <tui-loader size="s" *ngIf="loading"></tui-loader>
    </button>
  </div>
</div>
